export default __webpack_public_path__ + "static/media/01__o_4.34003aaa.jpg";